module.exports = __webpack_public_path__ + "img/sld_abt_meter_t1_b1_disable.a2cc1f0d.svg";